module.exports = __webpack_public_path__ + "6b6210e6ea91fbad7096a07490ddde24.png";